<template>
	<ClientOnly>
		<div class="cp-compare-container" :class="{'cd-btn-compare-container': mode == 'catalogDetail'}">
			<BaseCatalogSetCompare :item="item" v-slot="{onToggleCompare, active, message, loading, compareUrl}">
				<div class="cp-compare cp-btn compare" :class="{'cd-btn-compare-list': mode == 'catalogDetail', 'loading': loading, 'compare_active': active && !loading}" @click="onToggleCompare">
					<span class="loader" v-show="loading" />
					<span>
						<small class="l1">{{ labels.get('add_compare_product') }}</small>
						<small class="l2">{{ labels.get('remove_compare_product') }}</small>
					</span>
				</div>
				<span class="cp-compare-info compare_message" v-show="message">
					<span v-if="active" v-html="labels.get('compare_ok_added').replace('%view_compare_url%', compareUrl)" />
					<span v-if="!active" v-html="labels.get('compare_ok_removed').replace('%view_compare_url%', compareUrl)" />
				</span>
			</BaseCatalogSetCompare>
		</div>
	</ClientOnly>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['mode', 'item']);
</script>

<style lang="less" scoped>
	.cp-compare-container {
		margin-right: 10px; position: relative;
		@media (max-width: @m) {
			margin-right: 5px;
		}
	}
	:deep(.cp-compare) {
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 44px; height: 44px; border: 1px solid @borderColor; font-size: 0; line-height: 0; text-decoration: none; transition: opacity 0.3s, border-color 0.3s; cursor: pointer; position: relative;
		&:before {
			.pseudo(auto,auto); background: linear-gradient(315deg, #0078b4 0%, #0050a0 100%); left: 0; right: 0; top: 0; bottom: 0; opacity: 0; z-index: -1;
			.transition(opacity);
		}
		&:after {.icon-compare-horizontal(); font: 16px/16px @fonti; color: @textColor; .transition(color);}
		&.compare_active {
			border-color: transparent;
			&:before {opacity: 1;}
			&:after { color: @white; }
			@media (min-width: @t) {
				&:hover {
					border-color: transparent;
					&:after { .icon-trash(); }
				}
			}
		}
		&.loading{
			pointer-events: none;
			&:after{display: none;}
		}
		@media (min-width: @t) {
			&:hover { border-color: @borderColor / 1.3; text-decoration: none; z-index: 1; }
		}

		@media (max-width: @m) {
			&:after { font-size: 14px; line-height: 14px; }
		}
	}
	.loader{position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: url(/images/loader.svg) no-repeat center; background-size: 60% auto; z-index: 1;}
	.cp-compare-info{
		color: @textColor!important; background: #fff; white-space: nowrap; box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2); font-size: 12px; line-height: 1.5; position: absolute; bottom: calc(~'100% - -10px'); left: -10px; padding: 5px 10px; z-index: 11;
		&:after{.pseudo(8px,8px); background: #fff; .rotate(45deg); bottom: -4px; left: 28px; }
		a{color: @blue!important;}

		@media (max-width: @m){left: -6px;}
		@media (max-width: @ms){z-index: 1;}
	}

	.cd-btn-compare-container{
		display: flex!important; margin: 0 10px 0 0;
		:deep(.cp-compare){
			width: 60px; height: 60px;
			&:after{font-size: 18px; line-height: 18px;}
		}

		@media (max-width: @m){
			:deep(.cp-compare){
				width: 54px; height: 54px;
				&:after{font-size: 16px; line-height: 16px;}
			}
		}
		@media (max-width: @ms){position: absolute; bottom: 0; left: 0;}
	}
	.cd-compare-container-unavailable{
		margin: 0 0 0 10px;
		.cd-compare-info{
			left: unset!important; right: -10px;
			&:after{top: -4px; bottom: unset; left: unset!important; right: 35px;}
		}
		.cp-compare{width: 54px; height: 54px;}

		@media (max-width: @m){
			.cd-compare-info{
				left: -10px!important; right: unset;
				&:after{left: 34px!important; right: unset;}
			}
		}
	}
	.cd-compare-info{
		top: calc(~"100% - -10px"); bottom: unset;
		&:after{top: -4px; bottom: unset; left: 34px;}

		@media (max-width: @ms){z-index: 11;}
	}
</style>
